import Model from './model';

export default class LogicBaseCollection extends Model {
  constructor(_id, title, description, color, image, apps, owner, followers, editors, updateTime, socialShare, forceSubscribe, collectEmails, appTopics, premiumCollection, password, error) {
    super();
    this._id = _id;
    this.title = title;
    this.description = description;
    this.color = color;
    this.image = image;
    this.apps = apps || 0;
    this.owner = owner;
    this.followers = followers || 0;
    this.editors = editors || [];
    this.updateTime = updateTime;
    this.socialShare = socialShare;
    this.forceSubscribe = forceSubscribe;
    this.collectEmails = collectEmails;
    this.appTopics = appTopics;
    this.premiumCollection = premiumCollection;
    this.password = password;
    this.error = error;
  }
  getJson = () => {
    const { _id, title, description, color, image, apps, owner, followers, editors, socialShare, forceSubscribe, collectEmails, appTopics, premiumCollection, password } = this;
    return {
      _id,
      t: title,
      d: description,
      c: color,
      i: image,
      a: apps,
      o: owner,
      fr: followers,
      e: editors,
      ss: socialShare,
      fs: forceSubscribe,
      ce: collectEmails,
      at: appTopics,
      pc: premiumCollection,
      pw: password,
    }
  }
}
